<template>
  <div>
    <informations-general :fournisseur="fournisseur" />
    <adresse-fournisseurs :fournisseur="fournisseur" />
    <coordonnees-fournisseurs :fournisseur="fournisseur" />
    <section class="card mgt-20px">
      <header class="header-card">
        <p> {{ $t('addEditFournisseurs.contact.title')}} </p>
      </header>
      <div class="card-content">
        <app-contacts
          :contacts="fournisseur.contacts"
          :client="fournisseur"/>
      </div>
    </section>
    <info-comptable-fournisseurs :fournisseur="fournisseur" />
    <section v-if="isFactor" class="card mgt-20px">
      <header class="header-card">
        <p> {{ $t('addEditFournisseurs.commentaire.commentairesFactor')}} </p>
      </header>
      <div class="card-content">
        <div class="columns bottom">
          <div class="column is-12">
            <b-field :label="$t('addEditFournisseurs.commentaire.commentaire')">
              <qd-text-editor v-model="fournisseur.commentaireFactor" />
            </b-field>
          </div>
        </div>
      </div>
    </section>
    <section class="card mgt-20px">
      <header class="header-card">
        <p> {{ $t('addEditFournisseurs.commentaire.title')}} </p>
      </header>
      <div class="card-content">
        <div class="columns bottom">
          <div class="column is-12">
            <b-field :label="$t('addEditFournisseurs.commentaire.commentaire')">
              <textarea
                v-model="fournisseur.commentairesInternes"
                class="textarea"
                rows="6">
              </textarea>
            </b-field>
          </div>
        </div>
      </div>
    </section>
    <section class="card mgt-20px">
      <header class="header-card">
        <p>{{ $t('addEditFournisseurs.piecesJointes.title')}}</p>
      </header>
      <div class="card-content">
        <pieces-jointes
          :autoSave="detail"
          :read-only="detail"
          check-permissions/>
      </div>
    </section>
  </div>
</template>

<script>
import PiecesJointes from '@/components/general/piecesJointes';
import AppContacts from '@/components/clients/clients/editionClient/contacts';
import InformationsGeneral from '@/components/achat/fournisseurs/addEdit/informationsTab/informationsGeneral';
import AdresseFournisseurs from '@/components/achat/fournisseurs/addEdit/informationsTab/adresseFournisseurs';
import CoordonneesFournisseurs from '@/components/achat/fournisseurs/addEdit/informationsTab/coordonneesFournisseurs';
import InfoComptableFournisseurs from '@/components/achat/fournisseurs/addEdit/informationsTab/infoComptableFournisseurs';
import { TIERS_SOUS_TYPE_FACTOR } from '@/configuration/tiers/tiersConf';

export default {
  name: 'FournisseursInformationsGeneral',
  props: {
    fournisseur: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
    },
  },
  components: {
    AppContacts,
    PiecesJointes,
    InformationsGeneral,
    AdresseFournisseurs,
    CoordonneesFournisseurs,
    InfoComptableFournisseurs,
  },
  computed: {
    isFactor() {
      return this.isType(TIERS_SOUS_TYPE_FACTOR);
    },
  },
  methods: {
    isType(type) {
      return this.fournisseur.sousTypes.some((el) => el === type);
    },
  },
};
</script>
